export default {
    descriptionCalendar:"توضیحات تقویم",
    descriptionCenter:"توضیحات",
    date:"تاریخ"
}